<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<p class="toc-title">CONTENTS</p>
<p class="toc"><span href="#/Text/part0001" title="Link target outside of Sample"><em>Copyright</em></span></p>
<p class="toc" id="intr-1"><a href="#/Text/part0004"><em>Introduction</em></a></p>
<p class="toc" id="chap-1"><a href="#/Text/part0005">THE LAST PENNANT BEFORE ARMAGEDDON</a></p>
<p class="toc" id="chap-2"><span href="#/Text/part0006" title="Link target outside of Sample">THE BASEBALL SPUR</span></p>
<p class="toc" id="chap-3"><span href="#/Text/part0007" title="Link target outside of Sample">HOW I GOT MY NICKNAME</span></p>
<p class="toc" id="chap-4"><span href="#/Text/part0008" title="Link target outside of Sample">BUD AND TOM</span></p>
<p class="toc" id="chap-5"><span href="#/Text/part0009" title="Link target outside of Sample">NURSIE</span></p>
<p class="toc" id="chap-6"><span href="#/Text/part0010" title="Link target outside of Sample">THE NIGHT MANNY MOTA TIED THE RECORD</span></p>
<p class="toc" id="chap-7"><span href="#/Text/part0011" title="Link target outside of Sample">DRIVING TOWARD THE MOON</span></p>
<p class="toc" id="chap-8"><span href="#/Text/part0012" title="Link target outside of Sample">BAREFOOT AND PREGNANT IN DES MOINES</span></p>
<p class="toc" id="chap-9"><span href="#/Text/part0013" title="Link target outside of Sample">THE FIREFIGHTER</span></p>
<p class="toc" id="chap-10"><span href="#/Text/part0014" title="Link target outside of Sample">THE BATTERY</span></p>
<p class="toc" id="chap-11"><span href="#/Text/part0015" title="Link target outside of Sample">THE THRILL OF THE GRASS</span></p>
<p class="toc" id="ack-1"><span href="#/Text/part0016" title="Link target outside of Sample"><em>Acknowledgments</em></span></p>
<p class="toc" id="auth-1"><span href="#/Text/part0017" title="Link target outside of Sample"><em>About the Author</em></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0003.vue?36751210